import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table, Button } from 'antd';
import { OrganizationContext } from '../../../Services/OrganizationContext';
import authService from '../../../Services/authService';
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { usePermissions } from '../../../Services/PermissionsContext';
import DatePicker from "react-multi-date-picker";
import "react-multi-date-picker/styles/colors/red.css"; // Optional: Theme
import dayjs from "dayjs"; // For formatting

const AttendanceReport = () => {
  const permissions = usePermissions();
  const navigate = useNavigate();
  const { organization } = useContext(OrganizationContext);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const today = dayjs().format("YYYY-MM-DD");

  const [formData, setFormData] = useState({
    search: '',
    from_date: today,
    to_date: today,
  });


  useEffect(() => {
    if (organization) {
      loadAttendanceHistory(currentPage, pageSize, formData);
    }
  }, [organization]);


  const handlePageChange = (page, newPageSize) => {
    setCurrentPage(page);
    setPageSize(newPageSize);
    loadAttendanceHistory(page, newPageSize, formData);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleDateChange = (name, date) => {
    setFormData({ ...formData, [name]: date ? date.format("YYYY-MM-DD") : '' });
  };


  const loadAttendanceHistory = (page = 1, perPage = pageSize, filters) => {
    const token = authService.getCurrentadmin().token;
    const url = new URL(authService.getApiUrl() + 'attendancelist');

    fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        organization_id: organization,
        page,
        per_page: perPage,
        search: filters?.search || '',
        from_date: filters?.from_date || today,
        to_date: filters?.to_date || today,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (res.status === 401) {
          authService.logout();
          window.location.href = "/admin";
        } else {
          return res.json();
        }
      })
      .then((result) => {
        setData(result.data);
        setTotalRecords(result.total);
      })
      .catch((err) => {
        console.error(err.message);
      });
  };

  // const handleSubmit = (event) => {
  //   event.preventDefault();
  //   const token = authService.getCurrentadmin().token;

  //   fetch(authService.getApiUrl() + 'attendancelist', {
  //     method: 'POST',
  //     body: JSON.stringify({
  //       search: formData.search,
  //       from_date: formData.from_date,
  //       to_date: formData.to_date,
  //       organization_id: organization,
  //     }),
  //     headers: {
  //       Accept: 'application/json',
  //       'Content-Type': 'application/json; charset=UTF-8',
  //       Authorization: `Bearer ${token}`,
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((result) => {
  //       setData(result?.data || []);
  //       setTotalRecords(result?.total || 0);
  //     })
  //     .catch((err) => {
  //       console.error(err.message);
  //     });
  // };

  const handleSubmit = (event) => {
    event.preventDefault();
    setCurrentPage(1);
    loadAttendanceHistory(1, pageSize, formData);
  };

  const columns = [
    {
      title: "User Name",
      dataIndex: "user_name",
      render: (text) => <span>{text || '-'}</span>,
      sorter: (a, b) => (a.user_name || '').localeCompare(b.user_name || ''),
    },

    {
      title: "Date",
      dataIndex: "date",
      render: (text) => <span>{text || '-'}</span>,
      sorter: (a, b) => (a.date || '').localeCompare(b.date || ''),
    },
    {
      title: "Login Time",
      dataIndex: "check_in",
      render: (text) => <span>{text || '-'}</span>,
    },
    {
      title: "Logout Time",
      dataIndex: "check_out",
      render: (text) => <span>{text || '-'}</span>,
    },

    {
      title: "Status",
      dataIndex: "status",
      render: (text) => (
        <span
          className={text === "Present" ? "status-btn-green" : "status-btn-red"}
          style={{ whiteSpace: 'nowrap' }}
        >
          {text || '-'}
        </span>
      ),
    },
  ];


  const handleTableChange = (pagination) => {
    const { current, pageSize } = pagination;
    setCurrentPage(current);
    setPageSize(pageSize);
    loadAttendanceHistory(current, pageSize, formData);
  };

  return (
    <div className='main-container'>
      <div className='container-fluid'>
        <Breadcrumb />
        <div className='category-table'>
          <div className='flex-cont add-cat'>
            <div className='heading'>
              <h3>Attendance Report</h3>
            </div>
          </div>
          <div className='flex-cont just-cont-left bord-botm'>
            <div className='filter-search'>
              <input
                type="text"
                className="category-search"
                placeholder="Search by name"
                value={formData.search}   // ✅ make it controlled
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, search: e.target.value }))
                }
                name="search"
              />

              <DatePicker
                value={formData.from_date}
                onChange={(date) =>
                  setFormData((prev) => ({
                    ...prev,
                    from_date: date ? dayjs(date.toDate()).format("YYYY-MM-DD") : "",
                  }))
                }
                format="YYYY-MM-DD"
                placeholder="From date"
                className="form-control"
              />

              <DatePicker
                value={formData.to_date}
                onChange={(date) =>
                  setFormData((prev) => ({
                    ...prev,
                    to_date: date ? dayjs(date.toDate()).format("YYYY-MM-DD") : "",
                  }))
                }
                format="YYYY-MM-DD"
                placeholder="To date"
                className="form-control"
              />


              <Button type='primary' onClick={handleSubmit}>Search</Button>
            </div>
          </div>
          <div className='hospitals-table' id='hospitals_table'>
            <Table
              dataSource={data}
              columns={columns}
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: totalRecords,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '50'],
                onChange: handlePageChange,
                onShowSizeChange: handlePageChange,  // This ensures pageSize changes correctly
              }}
            />


          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceReport;
